<template>
  <div class="execution">
    <el-drawer
      size="920px"
      title="核算单详情"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
      :wrapperClosable="false"
    >
      <!-- <basic-container> -->
      <div class="pages">
        <el-collapse
          v-model="activeNames"
          v-for="(accountForm, index) in settleDetailList"
          :key="index"
        >
          <el-collapse-item
            :title="'结算单：' + accountForm.header.settleNo"
            class="custom-collapse-item"
            :name="index"
          >
            <div class="block-header" :ref="'print' + (index + 1)">
              <div class="top">
                <img src="@/static/zflogo.png" alt="" />
                <span> 核算单 </span>
              </div>
              <ul class="info">
                <li>
                  <label>结算单号：</label>
                  <span>{{ accountForm.header.settleNo }}</span>
                </li>
                <li>
                  <label>结算申请人：</label>
                  <span>{{ accountForm.header.agentName }}</span>
                </li>
                <li>
                  <label>项目名称：</label>
                  <span>{{ accountForm.header.projectName }}</span>
                </li>
                <li>
                  <label>运单数：</label>
                  <span>{{ accountForm.header.settleCnt }}</span>
                </li>
                <li>
                  <label>结算金额：</label>
                  <span>{{ accountForm.header.settleAmt }}</span>
                </li>
                <li>
                  <label>核算人：</label>
                  <span>{{ accountForm.header.settleName }}</span>
                </li>
              </ul>
              <div
                class="table"
                v-for="(item, index2) in accountForm.body"
                :key="index2"
              >
                <div class="tableTitle">
                  <span>承运人:{{ item.carrier_name }}</span
                  ><span class="red"
                    >共计{{ item.cnt }}车，{{ item.amt }}元</span
                  >
                </div>

                <div
                  class="inner"
                  v-for="(list, k) in item.detail"
                  :key="k + 100"
                >
                  <div class="tableTitle">
                    <span>{{ list.create_datetime }}</span
                    ><span class="red"
                      >共计{{ list.cnt }}车，{{ list.total_amt }}元</span
                    >
                  </div>
                  <el-table :data="list.detailDetail" border class="table">
                    <el-table-column
                      property="truckCode"
                      width="100px"
                      label="车牌号"
                    ></el-table-column>
                    <el-table-column
                      property="settleCnt"
                      label="运单数"
                    ></el-table-column>
                    <el-table-column
                      property="weightTons"
                      label="总数量"
                    ></el-table-column>
                    <el-table-column
                      property="weightUnit"
                      label="单位"
                    ></el-table-column>
                    <el-table-column
                      property="settlePrice"
                      label="单价"
                    ></el-table-column>
                    <el-table-column
                      property="payeePrice"
                      label="预付价总额"
                    ></el-table-column>
                    <el-table-column
                      property="totalAmt"
                      label="核算价总额"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="btn">
              <el-button
                size="small"
                type="primary"
                @click="downExport(accountForm.header.id)"
                >导出</el-button
              >
              <el-button
                size="small"
                :loading="btnLoading"
                @click="printPDF(accountForm.header.id)"
                >下载PDF打印</el-button
              >
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <!-- </basic-container> -->
    </el-drawer>
  </div>
</template>

<script>
import { expotOut } from "@/util/down.js";
import { downloadSettlePdf } from "@/api/chain/companysettle";

export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    //结算数据
    settleDetailList: {},
  },
  name: "companysettle",
  components: {},
  data() {
    return {
      activeNames: [0],
      accountForm: {},
      btnLoading: false,
    };
  },
  created() {},
  mounted: function () {
    // this.settleDetailList = JSON.parse(this.$route.query.value);
    // console.log(this.settleDetailList);
  },
  computed: {},
  methods: {
    //导出
    downExport(id) {
      console.log(id);
      let params = {
        settleId: id,
      };
      let url = "/chain/companysettle/exportExcelSettle";
      expotOut(params, url, "结算单");
    },
    printPDF(id) {
      this.btnLoading = true;
      let params = {
        settleId: id,
      };
      downloadSettlePdf(params)
        .then((res) => {
          console.log(res);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = "结算单.pdf"; //
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.btnLoading = false;
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  // border-bottom: 1px solid #ccc;
  padding: 20px;
  li {
    width: 33.3%;
    line-height: 25px;
    label {
      display: inline-block;
      // width: 116px;
      font-weight: 500;
      font-size: 14px;
      color: #313133;
    }
    span {
      font-weight: 400;
      font-size: 14px;
      color: #313133;
    }
  }
}
.isClick {
  color: #409eff;
  cursor: pointer;
  display: block;
  text-decoration: underline;
}
/deep/ .el-drawer__header {
  margin-bottom: 0px!important;
  padding: 11px 20px;
  border-bottom: 1px solid #ededf0;
  span {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
}
/deep/ .el-drawer__body {
  padding: 0px!important;
  // padding-bottom: 70px;
  #accountSheet {
    padding: 0 20px;
  }
  .demo-drawer__footer {
    width: 100%;
    text-align: center;
    background-color: rgba(204, 204, 204, 0.7);
    border-radius: 6px;
    line-height: 60px;
    position: absolute;
    bottom: 10px;
  }
}
.tableTitle {
  border: 1px solid #edeff0;
  // margin-left: 1px;
  border-top: none;
  // border-bottom: none;
  // line-height: 32px;
  // padding: 0px 10px;
  // color: #606266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f8fa;
  padding: 13px 20px;
  span {
    font-weight: 500;
    font-size: 16px;
    color: #313133;
  }
  .red {
    font-weight: 500;
    font-size: 14px;
    color: #35b1ff;
  }
}

/deep/ .el-table {
  // border-bottom: 1px solid #EDEFF0;
  // border-right: 1px solid #EDEFF0;
  tr {
    .el-table__cell {
      // border-left: 1px solid #EDEFF0;
      // border-top: 1px solid #EDEFF0;
    }
    border-right: 1px solid #edeff0;
  }
  .el-table__row {
    td {
      padding: 4px 0px;
    }
  }
  .el-table__header {
    th {
      padding: 4px 0px;
    }
  }
}
.block-header {
  border: 1px solid #edeff0;

  .top {
    line-height: 65px;
    height: 65px;
    position: relative;
    border-bottom: 2px solid #999999;
    span {
      font-weight: 500;
      font-size: 20px;
      color: #313133;
      text-align: center;
      text-decoration: underline;
      display: flex;
      justify-content: center;
    }
  }
  img {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 78px;
    height: 28px;
  }
}
.pages {
  margin: 32px;
  margin-top: 20px;
}
/deep/.el-table__header th.is-leaf {
  background: #fff !important;
}
.el-table__header th.is-leaf {
  border: 1px solid #edeff0;
}
.info1 {
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #ccc;
  // padding-bottom: 10px;
  margin: 40px 0;
  padding: 0 20px;
  margin-bottom: 26px;
  .left,
  .right {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    .label {
      font-weight: 500;
      font-size: 16px;
      color: #313133;
      margin-bottom: 14px;
    }
    .value {
      font-weight: 400;
      font-size: 14px;
      color: #313133;
    }
  }
  .right {
    margin-right: 100px;
  }
  li {
    text-align: left;
    margin-left: 20px;
    width: 50%;
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    margin-bottom: 14px;
    label {
      display: inline-block;
      width: 96px;
    }
    span {
      color: #666;
    }
  }
}
.footer {
  padding: 16px 24px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ededf0;
}
.custom-btn {
  background: #fff !important;
  &:hover {
    color: #35b1ff !important;
  }
}
.btn{
  margin-top: 10px;
}
/deep/.custom-collapse-item{
.el-collapse-item__wrap{
    border-width: 0;

  }
}
/deep/.el-collapse{
  border-top: none;
}
</style>
